import { Component } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { SvcBtnIconBaseComponent } from '../svc-btn-icon-base.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[svc-filled-btn-icon]',
  templateUrl: './svc-filled-btn-icon.component.html',
  styleUrls: ['./svc-filled-btn-icon.component.scss'],
  hostDirectives: [{ directive: MatRipple, inputs: ['matRippleDisabled:disabled'] }],
  host: {
    '[class.svc-filled-btn-icon]': `true`,
    '[class.svc-filled-btn-icon-danger]': `color === 'danger'`,
    '[class.svc-filled-btn-icon-text]': `color === 'text'`,
    '[class.svc-filled-btn-icon-primary]': `color === 'primary'`,
    '[class.svc-filled-btn-icon-on-primary]': `color === 'on-primary'`,
    '[class.svc-filled-btn-icon-disabled]': `disabled`,
  },
})
export class SvcFilledBtnIconComponent extends SvcBtnIconBaseComponent {}
